var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarBasic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.505 10.949a.665.665 0 00-.664.664v1.554a.665.665 0 00.664.664h.842a.665.665 0 00.664-.664v-1.554a.665.665 0 00-.664-.664h-.842zM17.075 13.882h-.842a.716.716 0 01-.716-.716v-1.553a.717.717 0 01.716-.716h.842a.717.717 0 01.716.716v1.553a.717.717 0 01-.716.716z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.517 12.638H2.011c-.66 0-1.197-.389-1.197-.867v-2.79l.72-.757h15.599l.58.76v2.787c0 .478-.537.867-1.197.867z",
    fill: "#9D9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.067 9.619H1.618l-.157-2.407.1-.247.58-1.428h14.297l.786 1.622-.157 2.46z",
    fill: "#9D9D9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#car-basic_svg__filter0_f_5476_25768)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.388,
    cy: 8.606,
    rx: 2.141,
    ry: 4.34,
    transform: "rotate(-45 9.388 8.606)",
    fill: "#C2C2C2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.197 7.164l-.115 1.809h-3.4V7.629l3.418-.664.097.2zM4.95 7.63v1.343H1.602l-.115-1.757.098-.24 3.365.653z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.352 5.95H2.227L3.734.928a1.008 1.008 0 01.96-.721l9.354-.09a1.012 1.012 0 01.99.76l1.314 5.073z",
    fill: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.265 5.475L3.313 5.333a.097.097 0 01-.091-.126l1.146-3.575a.097.097 0 01.092-.067h9.613a.097.097 0 01.092.067l1.193 3.717a.096.096 0 01-.093.126z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.236 5.846H.118v-.465a.568.568 0 01.568-.568h1.55v1.033zM18.463 5.846h-2.119V4.813h1.551a.568.568 0 01.568.568v.465z",
    fill: "#9D9D9D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "car-basic_svg__filter0_f_5476_25768",
    x: 2.551,
    y: 1.77,
    width: 13.673,
    height: 13.673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.707,
    result: "effect1_foregroundBlur_5476_25768"
  })))));
}
export default __webpack_public_path__ + "static/media/car-basic.192fe7b4.svg";
export { SvgCarBasic as ReactComponent };